import { render } from "./appointmentDetail.vue?vue&type=template&id=b0a5e6c0"
import script from "./appointmentDetail.vue?vue&type=script&lang=js"
export * from "./appointmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__